import { unref } from "vue";
import { u as useCaptureEvent } from "./useCaptureEvent-90d008ac.mjs";
import { f as findTeleportedFrom } from "./useTeleported-c9f0a2cb.mjs";
import { u as unwrapEl } from "../utils/unwrapEl-4d79d250.mjs";
const checkIfElementChild = (parent, child) => {
  if (!child) {
    return false;
  }
  if (child.parentElement === parent) {
    return true;
  }
  return parent.contains(child);
};
const safeArray = (a) => Array.isArray(a) ? a : [a];
const useClickOutside = (elements, cb) => {
  useCaptureEvent("click", (event) => {
    const clickTarget = event.target;
    if (event.target.shadowRoot) {
      return;
    }
    const teleportParent = findTeleportedFrom(clickTarget);
    const isClickInside = safeArray(elements).some((element) => {
      const el = unwrapEl(unref(element));
      if (!el) {
        return false;
      }
      if (!teleportParent) {
        return checkIfElementChild(el, clickTarget);
      }
      return checkIfElementChild(el, clickTarget) || checkIfElementChild(el, teleportParent);
    });
    if (!isClickInside) {
      cb(clickTarget);
    }
  });
};
export {
  useClickOutside as u
};
//# sourceMappingURL=useClickOutside-4e7f583c.mjs.map
